// extracted by mini-css-extract-plugin
export default {"list":"List--list--W27N6"};